import * as React from "react";

import type { AppFlyoutAnchorProps } from "@1js/acui-button";
import { UILocation } from "@1js/acui-common";
import type { AppIcons } from "@1js/acui-icons";
import type { ControlInMenuRendererFunction } from "@1js/acui-menu";

import { RibbonFlyoutAnchor } from "../Controls";

export function getDefaultRibbonFlyoutAnchorRenderer(
  appIcons: AppIcons,
  controlInMenuRendererFunction: ControlInMenuRendererFunction
) {
  return (props: AppFlyoutAnchorProps) => (
    <RibbonFlyoutAnchor
      {...props}
      controlInMenuRendererFunction={controlInMenuRendererFunction}
      downChevronIcon={appIcons.downChevron}
      location={props.location || UILocation.Ribbon}
    />
  );
}
